import React from 'react';
import { Package, Ship, Globe, Home, ArrowLeft } from 'lucide-react';

import "./Pagenotfound.css"

const PageNotFound = () => {
  return (
    <>
      <style>{`
        .page-404-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%);
          position: relative;
          overflow: hidden;
        }

        .bg-blob-1 {
          position: absolute;
          top: 5rem;
          left: 2.5rem;
          width: 16rem;
          height: 16rem;
          background: rgba(59, 130, 246, 0.3);
          border-radius: 50%;
          filter: blur(60px);
          animation: pulse 3s ease-in-out infinite;
        }

        .bg-blob-2 {
          position: absolute;
          bottom: 5rem;
          right: 2.5rem;
          width: 24rem;
          height: 24rem;
          background: rgba(245, 158, 11, 0.3);
          border-radius: 50%;
          filter: blur(60px);
          animation: pulse 3s ease-in-out infinite 0.7s;
        }

        .bg-blob-3 {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24rem;
          height: 24rem;
          background: rgba(249, 115, 22, 0.2);
          border-radius: 50%;
          filter: blur(60px);
          animation: pulse 3s ease-in-out infinite 1s;
        }

        .floating-icon-1 {
          position: absolute;
          top: 5rem;
          left: 5rem;
          animation: bounce 2s ease-in-out infinite 0.3s;
          opacity: 0.4;
        }

        .floating-icon-2 {
          position: absolute;
          bottom: 8rem;
          right: 8rem;
          animation: bounce 2s ease-in-out infinite 0.7s;
          opacity: 0.3;
        }

        .floating-icon-3 {
          position: absolute;
          top: 10rem;
          right: 10rem;
          animation: bounce 2s ease-in-out infinite 0.5s;
          opacity: 0.35;
        }

        .ship-icon {
          animation: bounce 2s ease-in-out infinite;
          filter: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
        }

        .package-spin {
          position: absolute;
          top: -1rem;
          right: -1rem;
          animation: spin 3s linear infinite;
        }

        .title-404 {
          font-size: 5rem;
          font-weight: 700;
          background: linear-gradient(to right, #60a5fa, #fbbf24, #fb923c);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: pulse 2s ease-in-out infinite;
        }

        .glass-card {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 1rem;
        }

        .btn-back {
          background: linear-gradient(to right, #3b82f6, #2563eb);
          border: none;
          color: white;
          font-weight: 600;
          border-radius: 0.75rem;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .btn-back:hover {
          background: linear-gradient(to right, #2563eb, #1d4ed8);
          transform: scale(1.05);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
          color: white;
        }

        .btn-home {
          background: linear-gradient(to right, #f59e0b, #f97316);
          border: none;
          color: white;
          font-weight: 600;
          border-radius: 0.75rem;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .btn-home:hover {
          background: linear-gradient(to right, #d97706, #ea580c);
          transform: scale(1.05);
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
          color: white;
        }

        .icon-arrow {
          transition: transform 0.3s ease;
        }

        .btn-back:hover .icon-arrow {
          transform: translateX(-0.25rem);
        }

        .icon-home {
          transition: transform 0.3s ease;
        }

        .btn-home:hover .icon-home {
          transform: scale(1.1);
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.7;
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-1.5rem);
          }
        }

        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @media (max-width: 768px) {
          .title-404 {
            font-size: 6rem;
          }
          .floating-icon-1, .floating-icon-2, .floating-icon-3 {
            display: none;
          }
        }
      `}</style>

      <div className="page-404-container d-flex align-items-center justify-content-center p-4">
    
        <div className="bg-blob-1"></div>
        <div className="bg-blob-2"></div>
        <div className="bg-blob-3"></div>

     
        <div className="floating-icon-1">
          <Package size={48} color="#60a5fa" />
        </div>
        <div className="floating-icon-2">
          <Ship size={64} color="#fbbf24" />
        </div>
        <div className="floating-icon-3">
          <Globe size={56} color="#fb923c" />
        </div>

   
        <div className="container position-relative" style={{ zIndex: 10 }}>
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10 col-xl-8 text-center">

         
              <div className="mb-4 position-relative d-inline-block">
                <Ship className="ship-icon" size={128} color="#f59e0b" strokeWidth={1.5} />
                <div className="package-spin">
                  <Package size={48} color="#60a5fa" />
                </div>
              </div>


              <h1 className="title-404 mb-4">404</h1>


              <h3 className="Website-title mb-3">
              Exporting Asia's Best Worldwide
              </h3>



              {/* <div className="glass-card p-4 mb-4">
                <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
                  <Globe size={24} color="#fbbf24" />
                  <p className="mb-0 fw-semibold" style={{ color: '#dbeafe' }}>International Trade Alert</p>
                </div>
                <p className="mb-0 small" style={{ color: '#bfdbfe' }}>
                  This route is currently unavailable. Our logistics team is working to redirect you to the right destination.
                </p>
              </div> */}


              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center">
                <button
                  onClick={() => window.location.href = '/'}
                  className="btn btn-home d-flex align-items-center gap-2 px-4 py-3"
                >
                  <ArrowLeft color='#fff' />
                  Go Back
                </button>
              </div>


              {/* <div className="mt-5 d-flex align-items-center justify-content-center gap-2 small" style={{color: '#93c5fd'}}>
                <Package size={16} />
                <span>•</span>
                <Ship size={16} />
                <span>•</span>
                <Globe size={16} />
                <span className="ms-2">Global Import & Export Solutions</span>
              </div> */}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;